import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    district,
    province,
    address,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    organizationName,
    taxId2,
    district2,
    province2,
    address2,
    phone2,
    fax2,
    email2,
    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [organizationName.name]: Yup.string().required(fullName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [email2.name]: Yup.string().required(email.errorMsg).email(email2.invalidMsg),
  [fax2.name]: Yup.string().optional(),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
});

export default validation;
